module.exports = __webpack_public_path__ + "media/images/help/experiences_1-39d7dfae80898519f0fd02cd3fedb4e1.gif";